import UtilService from "../../../services/UtilService";

/** Parse `GET /v1/puzzle/wordwheel/coins-catalog` → table rows. */
export function parseWordWheelCatalog(catalog) {
    if (!catalog || typeof catalog !== "object") {
        return [];
    }
    return Object.entries(catalog)
        .map(([length, coins]) => ({
            length: Number(length),
            coins: Number(coins),
        }))
        .filter((row) => Number.isFinite(row.length) && Number.isFinite(row.coins))
        .sort((a, b) => a.length - b.length);
}

export function formatWordWheelPlayDuration(startedAt, finishedAt) {
    const duration = UtilService.formatCompletionTime(startedAt, finishedAt);
    return duration || "Less than a minute";
}

export const WORD_WHEEL_HINT_COST = 5;

/** Coins for one word from catalog rows (`parseWordWheelCatalog`). */
export function resolveWordWheelCoinsForWord(word, catalogRows) {
    const len = (word || "").trim().length;
    if (!len || !Array.isArray(catalogRows) || catalogRows.length === 0) {
        return 0;
    }
    const exact = catalogRows.find((row) => row.length === len);
    if (exact) {
        return exact.coins;
    }
    const capped = [...catalogRows].filter((row) => row.length <= len).sort((a, b) => b.length - a.length)[0];
    return capped?.coins ?? 0;
}

export function sumWordWheelCoinsForWords(words, catalogRows) {
    if (!Array.isArray(words)) {
        return 0;
    }
    return words.reduce((sum, word) => sum + resolveWordWheelCoinsForWord(word, catalogRows), 0);
}
